import { Input } from "@chakra-ui/react";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { NumberQuestionProps } from "../types";

export const NumberQuestion = (props: NumberQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    isDisabled,
    changeEventHandler,
    answerProps,
    contentClassName,
    answerAriaLabel,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Input
          id={questionId}
          aria-label={answerAriaLabel}
          className={contentClassName}
          type="text"
          value={answer}
          onChange={changeEventHandler}
          placeholder={placeholder}
          maxLength={maxLength}
          isDisabled={isDisabled}
          {...answerProps}
          size={size}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
